import { useQuery } from '@eika-infrastruktur/react-query';
import { getBankName } from '../services/profileService';
const useBankInfo = (enabled = true) => useQuery({
    queryKey: ['bankinfo'],
    queryFn: getBankName,
    refetchOnWindowFocus: true,
    enabled,
    retry: 1,
});
export default useBankInfo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQmFua0luZm8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZmV0Y2hIb29rcy91c2VCYW5rSW5mby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFlLE1BQU0saUNBQWlDLENBQUM7QUFHeEUsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLDRCQUE0QixDQUFDO0FBRXpELE1BQU0sV0FBVyxHQUFHLENBQUMsT0FBTyxHQUFHLElBQUksRUFBeUIsRUFBRSxDQUMxRCxRQUFRLENBQVc7SUFDZixRQUFRLEVBQUUsQ0FBQyxVQUFVLENBQUM7SUFDdEIsT0FBTyxFQUFFLFdBQVc7SUFDcEIsb0JBQW9CLEVBQUUsSUFBSTtJQUMxQixPQUFPO0lBQ1AsS0FBSyxFQUFFLENBQUM7Q0FDWCxDQUFDLENBQUM7QUFFUCxlQUFlLFdBQVcsQ0FBQyJ9